import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert, FormFeedback } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";

import Footer from "../ComponentPrimer/Footer";

const schools = [
  "SMAN 4 Padang",
  "SMAN 14 Padang",
  "SMAS Adabiah 1 Padang",
  "SMAS Kartika 1-5 Padang",
  "SMAS Pertiwi 1 Padang",
  "SMKN 4 Padang",
];

const FormOpenHouse = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null); // State to store alert message

  const toggleModal = () => setModalOpen(!modalOpen);

  const formik = useFormik({
    initialValues: {
      nama: "",
      hp: "",
      email: "",
      gender: "",
      school: "",
    },
    validationSchema: Yup.object({
      nama: Yup.string().required("Nama harus diisi"),
      hp: Yup.string()
        .matches(
          /^(0\d{9,17}|(\+62)\d{9,17})$/,
          "Nomor HP tidak valid"
        )
        .required("Nomor HP harus diisi"),
      email: Yup.string().email("Email tidak valid").required("Email harus diisi"),
      gender: Yup.string().required("Jenis kelamin harus dipilih"),
      school: Yup.string().required("Asal sekolah harus dipilih"),
    }),
    onSubmit: async (values) => {
      // Format nomor HP
      let formattedHP = values.hp;
      if (formattedHP.startsWith("0")) {
        formattedHP = "62" + formattedHP.slice(1);
      } else if (formattedHP.startsWith("+62")) {
        formattedHP = formattedHP.slice(1);
      }

      // Cek apakah nomor HP sudah terdaftar
      axios
        .get(`https://app.rlagency.id/apiopenhouse/check-phone.php?phone=${formattedHP}`)
        .then((response) => {
          if (response.data.exists) {
            // Jika sudah terdaftar, tampilkan alert
            setAlertMessage(`Anda sudah terdaftar dengan nama ${response.data.name}`);
          } else {
            // Jika belum terdaftar, kirim data ke server
            const qrcodeData = formattedHP * 2;
            const payload = {
              name: values.nama,
              phone: formattedHP,
              gender: values.gender,
              school: values.school,
              qrcode: qrcodeData,
            };

            axios
              .post("https://app.rlagency.id/apiopenhouse/register-peserta.php", payload)
              .then((response) => {
                setFormData({
                  ...values,
                  formattedHP,
                  qrcodeData,
                });
                toggleModal();
                setAlertMessage(null); // Reset alert message on successful registration

                sendEmailWithQRCode(values.email, qrcodeData);
              })
              .catch((error) => {
                console.error("Error submitting form:", error);
                alert("Terjadi kesalahan saat mengirim data.");
              });
          }
        })
        .catch((error) => {
          console.error("Error checking phone:", error);
          alert("Terjadi kesalahan saat memeriksa nomor HP.");
        });
    },
  });

  const downloadIDCardAsImage = () => {
    const modalContent = document.getElementById("modal-content");
    html2canvas(modalContent).then((canvas) => {
      const imageUrl = canvas.toDataURL("image/jpeg");
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = `${formData.nama}-idcard.jpg`;
      link.click();
    });
  };

  const captureModalAsImage = async () => {
    const modalContent = document.getElementById("modal-content");
    const canvas = await html2canvas(modalContent);
    return canvas.toDataURL("image/jpeg"); // Harus mengembalikan base64
  };
  
  const sendEmailWithQRCode = async (email, qrcodeData) => {
    try {
      // Mengambil gambar QR Code dari modal
      const qrcodeImage = await captureModalAsImage();
  
      // Log untuk memastikan qrcodeImage adalah string base64 yang valid
      console.log('QR Code Base64:', qrcodeImage); 
  
      if (!qrcodeImage || !qrcodeImage.startsWith('data:image/jpeg;base64,')) {
        throw new Error("QR Code tidak valid.");
      }
  
      // Membuat payload untuk dikirimkan ke server
      const emailPayload = {
        to: email,
        subject: "QR Code untuk Kehadiran Open House",
        message: `Hai, ${formData.nama},<br><br>
                  Berikut adalah QR Code Anda untuk kehadiran di Open House UPI YPTK 2024.<br><br>
                  Silakan simpan QR Code ini untuk menunjukkan bukti kehadiran Anda.<br><br>
                  Terima kasih!<br>
                  <b>UPI YPTK Padang</b>`,
        qrcodeImage: qrcodeImage, // Pastikan ini adalah base64 yang valid
      };
  
      console.log("Email Payload:", emailPayload); // Log data yang dikirim
  
      // Kirimkan request POST ke API PHP
      const response = await axios.post(
        "https://app.rlagency.id/apiopenhouse/send-email.php",
        emailPayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.data.success) {
        alert("Email dengan QR Code telah dikirim.");
      } else {
        throw new Error("Gagal mengirim email");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Terjadi kesalahan saat mengirim email.");
    }
  };  
  
  return (
    <div>
    <div className="container" style={{ padding: "20px", maxWidth:'700px'}}>
      <h1 style={{ textAlign: "start", marginBottom: "20px", fontSize: "26px", textTransform:'uppercase', fontStyle:'italic' }}>Form Kehadiran Open House <br/>UPI YPTK 2024</h1>
      <hr/>
      <p>Bagi adik-adik siswa SMA yang diundang untuk hadir di acara Open House UPI YPTK Padang tahun 2024, silahkan mengisi form berikut :</p>

      {/* Alert Message */}
      {alertMessage && <Alert color="danger">{alertMessage}</Alert>}

      <Form onSubmit={formik.handleSubmit}>
        <FormGroup>
          <Label for="nama">Nama</Label>
          <Input
            id="nama"
            name="nama"
            type="text"
            value={formik.values.nama}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={formik.touched.nama && formik.errors.nama}
          />
          {formik.touched.nama && formik.errors.nama && <FormFeedback>{formik.errors.nama}</FormFeedback>}
        </FormGroup>

        <FormGroup>
          <Label for="hp">HP</Label>
          <Input
            id="hp"
            name="hp"
            type="text"
            value={formik.values.hp}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={formik.touched.hp && formik.errors.hp}
          />
          {formik.touched.hp && formik.errors.hp && <FormFeedback>{formik.errors.hp}</FormFeedback>}
        </FormGroup>

        <FormGroup>
          <Label for="email">Email</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={formik.touched.email && formik.errors.email}
          />
          {formik.touched.email && formik.errors.email && <FormFeedback>{formik.errors.email}</FormFeedback>}
        </FormGroup>

        <FormGroup>
          <Label for="gender">Jenis Kelamin</Label>
          <Input
            type="select"
            name="gender"
            id="gender"
            value={formik.values.gender}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={formik.touched.gender && formik.errors.gender}
          >
            <option value="">Pilih Jenis Kelamin</option>
            <option value="Laki-laki">Laki-laki</option>
            <option value="Perempuan">Perempuan</option>
          </Input>
          {formik.touched.gender && formik.errors.gender && <FormFeedback>{formik.errors.gender}</FormFeedback>}
        </FormGroup>

        <FormGroup>
          <Label for="school">Asal Sekolah</Label>
          <Input
            type="select"
            name="school"
            id="school"
            value={formik.values.school}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={formik.touched.school && formik.errors.school}
          >
            <option value="">Pilih Sekolah</option>
            {schools.map((school, index) => (
              <option key={index} value={school}>
                {school}
              </option>
            ))}
          </Input>
          {formik.touched.school && formik.errors.school && <FormFeedback>{formik.errors.school}</FormFeedback>}
        </FormGroup>

        <Button color="primary" type="submit">
          Submit
        </Button>
      </Form>

      {/* Information Box */}
      <div style={{
        marginTop: "30px",
        padding: "30px",
        border: "none",
        borderRadius: "10px",
        backgroundColor: "#E7F2FF",
        fontSize: "14px",
        marginBottom:'50px'
      }}>
        <h5 style={{ fontWeight: "bold" }}>Informasi Penting :</h5>
        <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
          <li>Setelah mengisi form, adik-adik akan mendapatkan barcode kehadiran. Silahkan di download dan disimpan.</li>
          <li>Barcode juga dikirimkan ke email. Pastikan Email yang didaftarkan adalah Email aktif yang digunakan.</li>
          <li>Tunjukkan BARCODE kepada panitia saat memasuki RUANGAN ACARA sebagai BUKTI KEHADIRAN.</li>
        </ul>
      </div>

      {/* Modal */}
      {formData && (
        <Modal isOpen={modalOpen} toggle={toggleModal} size="sm" centered>
        <ModalHeader toggle={toggleModal}>Pendaftaran Berhasil</ModalHeader>
        <ModalBody id="modal-content" style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>
          <div style={{
            width: "300px",
            border: "1px solid #000",
            padding: "20px 0px",
            textAlign: "center",
            borderRadius: "10px",
          }}>
            <div >
              <h5 style={{padding:'0px', margin:'0px', fontSize:'20px', textTransform:'uppercase', fontWeight:'500'}}>{formData.nama}</h5>
              <p style={{padding:'0px', margin:'0px', color:'#1b1b1b', fontSize:'15px', textTransform:'uppercase'}}>{formData.school}</p>
              <hr style={{padding:'0px', margin:'10px auto', width:'70%', borderColor:'#1b1b1b'}}/>
            </div>
            <div style={{ marginTop: "30px" }}>
              <QRCodeCanvas value={formData.qrcodeData.toString()} />
            </div>
            <div >
              <p style={{padding:'0px 30px', marginTop:'20px', color:'#1b1b1b', fontSize:'13px'}}>*Simpan/ Screenshoot QR Code agar kamu diizinkan memasuki venue/ gedung acara.</p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button style={{width:'100%', fontSize:'16px'}} color="primary" onClick={downloadIDCardAsImage}>
            Download QR
          </Button>
        </ModalFooter>
      </Modal>
      )}
    </div>
    <Footer />
    </div>
  );
};

export default FormOpenHouse;
